import React, { useState } from 'react';
import { getGradientClass } from '../constants/theme';

export default function TeamMemberCard({ racer, index = 0 }) {
    const [isHovered, setIsHovered] = useState(false);

    const gradientClass = getGradientClass(index);
    const speed = racer.speed ?? 80;
    const endurance = racer.endurance ?? 80;

    return (
        <div 
            className="relative group cursor-pointer"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div className={`bg-gradient-to-br ${gradientClass} p-0.5 rounded-lg hover:scale-105 transition-transform duration-200`}>
                <div className="bg-gray-800 rounded-lg overflow-hidden transition-all duration-300 transform hover:shadow-xl">
                <div className="relative overflow-hidden">
                    <img
                        src={racer.photo}
                        alt={racer.name}
                        className="w-full h-64 object-cover object-top transition-transform duration-500 group-hover:scale-110"
                        loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
                
                <div className="p-4">
                    <h3 className="text-lg font-bold text-white mb-1 group-hover:text-sky-400 transition-colors duration-300">
                        {racer.name}
                    </h3>
                    <p className="text-gray-400 text-xs mb-1">Specialty</p>
                    <p className="text-gray-300 text-sm mb-2 italic">{racer.specialty}</p>
                    
                    <div className="space-y-2">
                        <div className="flex justify-between text-xs text-gray-400">
                            <span>Speed</span>
                            <span>{speed}%</span>
                        </div>
                        <div className="w-full bg-gray-700 rounded-full h-1">
                            <div 
                                className="bg-gradient-to-r from-sky-400 to-yellow-400 h-1 rounded-full transition-all duration-1000 ease-out"
                                style={{ width: `${speed}%` }}
                            />
                        </div>
                        
                        <div className="flex justify-between text-xs text-gray-400">
                            <span>Endurance</span>
                            <span>{endurance}%</span>
                        </div>
                        <div className="w-full bg-gray-700 rounded-full h-1">
                            <div 
                                className="bg-gradient-to-r from-yellow-400 to-sky-400 h-1 rounded-full transition-all duration-1000 ease-out"
                                style={{ width: `${endurance}%` }}
                            />
                        </div>
                    </div>
                </div>
                </div>
            </div>
            
            {isHovered && (
                <div className="absolute -top-2 -right-2 animate-bounce z-10">
                    <div className="bg-yellow-400 text-gray-900 rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold">
                        🏆
                    </div>
                </div>
            )}
        </div>
    );
}
